import { Box, Dialog, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export default function CodebarModal () {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const { t } = useTranslation();

    return (
        <Box>
            {t('collections.table.columns.barCode')}
            <IconButton size="small" >
                <HelpOutlineIcon color='primary' onClick={() => setShow(true)} />
            </IconButton>

            <Dialog
                open={show}
                onClose={handleClose}
                PaperProps={{ style: { padding: '5px', borderRadius: '16px' } }}
            >
                <Typography variant='h1' padding={2} sx={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>
                    {t('collections.table.info.title')}
                </Typography>

                <Box>
                    <img src='/assets/codebar.png' alt='codebar' style={{ width: '500px', padding: '5px' }} />
                </Box>
                <Typography variant='h3'>
                    <ol>
                        <li>{t('collections.table.info.1')}</li>
                        <li>{t('collections.table.info.2')}</li>
                        <li>{t('collections.table.info.3')}</li>
                        <li>{t('collections.table.info.4')}</li>
                        <li>{t('collections.table.info.5')}</li>
                        <li>{t('collections.table.info.6')}</li>
                        <li>{t('collections.table.info.7')}</li>
                        <li>{t('collections.table.info.8')}</li>
                    </ol>
                </Typography>
            </Dialog>
        </Box>
    );
}
